import React from 'react';
import styled from 'styled-components';
import { spaces, colors } from '../../lib/styles';
import Down1 from '../../components/Icon/components/Down1';

const SelectWrapper = styled.div`
    position: relative;
`;

const StyledSelect = styled.select`
    overflow: hidden;
    width: 100%;
    height: ${spaces.space11}px;
    appearance: none;
    -moz-appearance: none;
    padding-left: ${spaces.space4}px;
    border-radius: 5px;
    border: ${spaces.space2}px solid ${colors.grey500};
    background-color: ${colors.white};
    cursor: pointer;

    &:hover {
        border-color: ${colors.grey700};
    }
`;

const StyledTrigger = styled(Down1)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: ${spaces.space5}px;
    font-size: inherit;
    line-height: inherit;
    pointer-events: none;
    z-index: 1;
    margin-right: ${spaces.quarterGutter}px;
`;

export interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
    children: React.ReactNode;
}

function Select({ children, ...props }: Props) {
    return (
        <SelectWrapper>
            <StyledSelect {...props}>{children}</StyledSelect>
            <StyledTrigger />
        </SelectWrapper>
    );
}

export default Select;
